import { API, DownloadRequestStatus } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  id: number;
  status: DownloadRequestStatus;
  spaceId: number;
  expiresAt?: number | "now";
  message?: string;
  sendEmail?: boolean;
};

const [useUpdateDownloadRequest, updateDownloadRequest] = createAsyncAction(
  "downloadRequests/update",
  async ({ spaceId, id, status, expiresAt, message, sendEmail }: Args) => {
    const res = await API.call<{ request: string }>({
      endpoint: `spaces/${spaceId}/download-requests/${id}`,
      method: "PUT",
      data: {
        status,
        message,
        expires_at: expiresAt,
        send_email: sendEmail,
      },
    });
    return { ...res, result: res.result.request };
  }
);

export default useUpdateDownloadRequest;
export { updateDownloadRequest };
